<script setup>
/**
 * Typography for the Jetstream-rendered policy/terms markdown (GH-1121).
 *
 * The HTML arrives pre-rendered, so the type is applied through descendant
 * variants. Every rule is explicit rather than inherited: these pages keep
 * app.scss (members SPA-navigate to them from legacy pages), whose bare
 * element rules — `p { line-height: 1 }`, `a { color: #2484c6 }`, heading
 * fonts — would otherwise leak in. The markdown's own H1 duplicates the hero
 * title, so it is hidden.
 */
defineProps({
    html: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div
        class="font-brand text-[15px] leading-[19px] text-[#3c3938] [&_a]:text-[#3c3938] [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-brand-red [&_h1]:hidden [&_h2:first-of-type]:mt-0 [&_h2]:mb-[17px] [&_h2]:mt-[35px] [&_h2]:font-brand [&_h2]:text-[15px] [&_h2]:font-bold [&_h2]:uppercase [&_h2]:leading-[19px] [&_h2]:tracking-normal [&_h2]:text-[#3c3938] [&_h3]:mb-[10px] [&_h3]:mt-[26px] [&_h3]:font-brand [&_h3]:text-[15px] [&_h3]:font-bold [&_h3]:leading-[19px] [&_h3]:tracking-normal [&_h3]:text-[#3c3938] [&_li]:mb-1 [&_li]:leading-[19px] [&_p:last-child]:mb-0 [&_p]:mb-[19px] [&_p]:leading-[19px] [&_strong]:font-bold [&_ul_ul]:mb-0 [&_ul_ul]:mt-1 [&_ul]:mb-[19px] [&_ul]:list-disc [&_ul]:pl-6"
        v-html="html"
    ></div>
</template>
